import { Tab } from '../../../../../views/customer-base';
import { BillingTypeOptions } from '../../../../../views/customer-base/BillingHealthTab';
import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tabs: {
    [Tab.Performance]: 'Prestaties',
    [Tab.NewCustomers]: 'Nieuwe restaurants',
    [Tab.CustomerHealth]: 'Klantstatus',
    [Tab.LiveAndInactive]: 'Actief en inactief',
    [Tab.BillingHealth]: 'Factuurstatus',
  },
  labels: {
    sales_manager: 'Verkoopmanager',
  },
  performance_tab: {
    table_columns: {
      name: 'Naam',
      sales_manager: 'Verkoopmanager',
      orders: 'Bestellingen',
      sales: 'Omzet',
      previous_month_sales: 'Omzet vorige maand',
    },
    labels: {
      sales_volume: 'Verkoopvolume:',
      all: 'Alle',
      click_to_sort: 'Klik om te sorteren',
      no_data: 'Geen gegevens',
    },
    toasts: {
      failed_to_load_data: 'Gegevens laden mislukt',
    },
  },

  new_restaurants_tab: {
    table_columns: {
      name: 'Naam',
      sales_manager: 'Verkoopmanager',
      orders: 'Bestellingen',
      sales: 'Omzet',
      days_live: 'Dagen actief',
      early_performance: 'Vroege prestaties',
    },
    labels: {
      click_to_sort: 'Klik om te sorteren',
      no_data: 'Geen gegevens',
      only_with_early_performance: 'Alleen met vroege prestaties: ',
      early_performance_yes: '✔️ Ja',
      early_performance_no: '✗ Nee',
    },
    toasts: {
      failed_to_load_data: 'Gegevens laden mislukt',
    },
  },

  customer_health_tab: {
    titles: {
      sales_tiers: 'Omzetniveaus',
      payments_ratio: 'Betalingsverhouding',
    },
    dataset_labels: {
      negative: 'Negatief ({{values}})',
      ok: 'OK ({{values}})',
      good: 'Goed ({{values}})',
      excellent: 'Uitstekend ({{values}})',
    },

    companies_preview_modal: {
      title: 'Restaurantoverzicht',
      table_columns: {
        name: 'Naam',
        sales_manager: 'Verkoopmanager',
        orders: 'Bestellingen',
        sales: 'Omzet',
        total_payments: 'Totale betalingen',
        payments_ratio: 'Betalingsverhouding',
      },
      labels: {
        close: 'Sluiten',
        click_to_sort: 'Klik om te sorteren',
        no_data: 'Geen gegevens',
      },
    },
    toasts: {
      failed_to_load_data: 'Gegevens laden mislukt',
    },
  },

  live_and_inactive_tab: {
    dataset_labels: {
      live: 'Actief',
      no_orders: 'Geen bestellingen',
      no_conversion: 'Geen conversie',
    },
    toasts: {
      failed_to_load_data: 'Gegevens laden mislukt',
    },
  },

  billing_health_tab: {
    filters: {
      billing_type: {
        label: 'Factureringstype',
        options: {
          [BillingTypeOptions.Subscription]: 'Abonnement',
          [BillingTypeOptions.Manual]: 'Overig',
        },
      },
      high_risk_only: {
        label: 'Alleen hoogrisicoklanten',
      },
    },
    fields: {
      name: 'Naam',
      live_from: 'Live vanaf',
      billing_mode: {
        title: 'Factureringsbron',
        options: {
          [BillingMode.Stripe]: 'Betaalmethode',
          [BillingMode.InternalInvoicing]: 'Omzet',
        },
      },
      trial_ends_at: 'Einde proefperiode',
      last_failed_invoice_amount: 'Bedrag laatste mislukte factuur',
      failed_payments_count: 'Aantal mislukte betalingen',
    },
    tags: {
      is_high_billing_risk_customer: 'Hoog factureringsrisico',
    },
    toasts: {
      failed_to_load_data: 'Gegevens laden mislukt',
    },
  },
};
